import { z } from 'zod';

import { modelPropertyType } from '~/lib/api/models';

import PropertyTeaseAside from './PropertyTeaseAside';
import PropertyTeaseSwiper from './PropertyTeaseSwiper';

export type Props = z.infer<
  typeof modelPropertyType.schema
>['propertyType']['properties']['edges'][number]['node'];

const PropertyTease: React.FC<Props> = (property) => {
  return (
    <article
      className="relative w-full overflow-clip lg:my-2"
      data-property={property.slug}
    >
      <div className="relative flex grid-cols-[auto_1fr_auto] flex-col px-2 lg:grid lg:h-[calc(100svh-160px)]">
        <PropertyTeaseAside side="left" {...property} />
        <PropertyTeaseSwiper {...property} />
        <PropertyTeaseAside side="right" {...property} />
      </div>
    </article>
  );
};

export default PropertyTease;
